/**
 * Created by Ning Jiang on 11/22/2016.
 */

import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {BonusBunniesGameModuleConfig} from "./BonusBunniesGameModuleConfig";
import {WinFieldController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinFieldController";
import {REWinFieldController} from "./keypad/REWinFieldController";

export class BonusBunnies extends SlotGame {

    constructor() {
        super(BonusBunniesGameModuleConfig.instance);
    }

    protected createWinFieldController():WinFieldController {
        return new REWinFieldController();
    }


    getNoWinGameData():any {
        return {
            "reels": [
                [
                    "M4",
                    "M4",
                    "M4",
                    "L2",
                    "L3",
                    "L3",
                    "M2"
                ],
                [
                    "M1",
                    "L4",
                    "L1",
                    "L1",
                    "L3",
                    "M4",
                    "M4"
                ],
                [
                    "L5",
                    "M2",
                    "L1",
                    "M3",
                    "L5",
                    "L5",
                    "L5"
                ],
                [
                    "L1",
                    "M2",
                    "M2",
                    "M2",
                    "M1",
                    "M4",
                    "L2"
                ],
                [
                    "M4",
                    "M3",
                    "L1",
                    "M1",
                    "L2",
                    "L5",
                    "L1"
                ]
            ],
            "evaluatedReels": [
                [
                    "M4",
                    "M4",
                    "L2",
                    "L3"
                ],
                [
                    "L4",
                    "L1",
                    "L1",
                    "L3"
                ],
                [
                    "M2",
                    "L1",
                    "M3",
                    "L5"
                ],
                [
                    "M2",
                    "M2",
                    "M2",
                    "M1"
                ]
            ],
            "betLineWins": [],
            "totalSpinWinnings": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": 1,
            "nearWinReels": [
                false,
                false,
                false,
                false,
                false
            ],
            "reelsNextSpin": "BASE_REELSET",
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "winMultiplier": 1,
            "overlayPositions": [
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ]
            ],
            "overlaySymbol": "",
            "bonusSymbolTriggered": false,
            "bonusSpinsRemaining": 0,
            "bonusSpinsPlayed": 0,
            "reelsEnteringBonus": [
                [
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null
                ]
            ],
            "wildPositions": [
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ]
            ],
            "bonusPositionsBeforeSpin": [
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ]
            ],
            "bonusPositionsAfterSpin": [
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ]
            ],
            "bonusNewPositions": [
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false
                ]
            ],
            "bottomRowActivated": false,
            "lastReelActivated": false,
            "bottomRowTriggered": false,
            "lastReelTriggered": false,
            "bonusValuesBeforeSpin": [
                [
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0
                ]
            ],
            "bonusValuesLanding": [
                [
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0
                ]
            ],
            "bonusValuesAfterSpin": [
                [
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0
                ]
            ],
            "spinsReset": false,
            "triggeredWildExpansion": false,
            "allWinPositions": [
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ]
            ],
            "bonusOverlaySymbols": [
                [
                    "",
                    "",
                    "",
                    "",
                    ""
                ],
                [
                    "",
                    "",
                    "",
                    "",
                    ""
                ],
                [
                    "",
                    "",
                    "",
                    "",
                    ""
                ],
                [
                    "",
                    "",
                    "",
                    "",
                    ""
                ],
                [
                    "",
                    "",
                    "",
                    "",
                    ""
                ]
            ],
            "totalBonusWinMultiplierBefore": 0,
            "totalBonusWinMultiplierAfter": 0,
            "bonusSymbolQueue": [],
            "allPositionsFilled": false,
            "lastBonusSymbolPosition": [
                -1,
                -1
            ],
            "lastBonusSymbolPositionExcitement": [
                -1,
                -1
            ],
            "featureBuyTimesBetValue": [
                {
                    "name": "FREESPIN",
                    "type": "FREESPIN",
                    "price": 60
                }
            ],
            "wasFeatureBuy": false,
            "endBonusMultiplier": 1
        };
    }
}